export default class StatModel {
    public instruction = '';

    public considered = 0;

    public selected = 0;

    public statistics?: {[key: string]: string|number} = undefined;
}
